
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit/records",
      function () {
        return require("private-next-pages/credit/records/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit/records"])
      });
    }
  